/**
 * @Description 图层设置列表
 */
import { FC } from 'react';
import styles from '../index.module.less';
import cs from 'classnames';
import { leftListSelectionDOM } from '../../../../ts-config';
import HeatMap from './HeatMap';
import BorderSwitch from './BorderSwitch';
import LayerSubway from './LayerSubway';

const LayerList:FC<any> = ({
  selectionListRef,
  setActive,
  mapIns,
  cityProvinceInfo,
  isOpenBorder,
  setIsOpenBorder,
  isOpenSubway,
  setIsOpenSubway,
  isShape,
}) => {

  return <div
    className={cs(styles.selectionListCon, styles.right)}
  >
    <div className={styles.top}>
      <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/icon_siteselectionmap_leftLayer.png`} alt='' className={styles.textImg}/>
      <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/icon_siteselectionmap_arrow.png`} alt='' className={styles.arrowImg}/>
    </div>
    <div
      className={cs(leftListSelectionDOM, styles.list)}
      ref={selectionListRef || null}
    >
      {/* 开店区域围栏 */}
      <BorderSwitch
        isOpenBorder={isOpenBorder}
        setIsOpenBorder={setIsOpenBorder}
        setActive={setActive}
        isShape={isShape}
      />
      {/* 居住、餐饮热力图 */}
      <HeatMap
        setActive={setActive}
        mapIns={mapIns}
        cityProvinceInfo={cityProvinceInfo}
      />
      {/* 地铁 */}
      <LayerSubway
        cityProvinceInfo={cityProvinceInfo}
        mapIns={mapIns}
        setActive={setActive}
        isOpenSubway={isOpenSubway}
        setIsOpenSubway={setIsOpenSubway}
      />
    </div>

  </div>
  ;
};
export default LayerList;
